import { render, staticRenderFns } from "./ProvinceRiskModal.vue?vue&type=template&id=29f24dd2&scoped=true&"
import script from "./ProvinceRiskModal.vue?vue&type=script&lang=js&"
export * from "./ProvinceRiskModal.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceRiskModal.vue?vue&type=style&index=0&id=29f24dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f24dd2",
  null
  
)

export default component.exports